import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@dixa/lib-shared-habla';
import { analytics } from 'app/utils/segment';
import { actions as companyModalActions } from 'components/shared/companyModal/actions/companyModal';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { ContactInfo } from '../../../contactInfo/contactInfo';
export function CompanyInfo({ company }) {
    const { name } = company;
    const primaryLabel = name;
    const dispatch = useAppDispatch();
    const handleEditCompany = () => {
        analytics.contactsCardEditCompanyClicked();
        dispatch(companyModalActions.companyModalShow({ company }));
    };
    const actions = (_jsx(Button, Object.assign({ icon: "pen", variant: "secondary", onClick: handleEditCompany }, { children: "Edit" })));
    return (_jsx(ContactInfo, { avatar: company, primaryLabel: primaryLabel, actions: actions }));
}
